import {
  ElectricBolt as ElectricIcon,
  HelpOutlineOutlined as AboutIcon,
  Palette as PaletteIcon,
  RotateLeft as RotateLeftIcon,
  Tune as TuneIcon,
} from '@mui/icons-material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MiniSidebar } from 'src/components/sidebar';
import { PATHS } from 'src/constants/paths';
import { getPaths, lang } from 'src/utils';

import { Container, Content } from './SettingsSubNavbar.styled';

export const SettingsSubNavbar = () => {
  const navigate = useNavigate();
  let location = useLocation();
  const paths = getPaths(location.pathname);
  const items = [
    {
      icon: <TuneIcon />,
      onClick: () => navigate({ pathname: PATHS.SETTINGS_CONFIGURATIONS }),
      isSelected: paths.includes(PATHS.SETTINGS_CONFIGURATIONS),
      tooltipMessage: lang.headerGlobalConfigTitle,
    },
    {
      icon: <PaletteIcon />,
      onClick: () => navigate({ pathname: PATHS.SETTINGS_ACCESSIBILITY }),
      isSelected: paths.includes(PATHS.SETTINGS_ACCESSIBILITY),
      tooltipMessage: lang.headerAccessibilityConfigTitle,
    },
    {
      icon: <ElectricIcon />,
      onClick: () =>
        navigate({ pathname: PATHS.SETTINGS_CUSTOMER_TRIGGERED_EVENTS }),
      isSelected: paths.includes(PATHS.SETTINGS_CUSTOMER_TRIGGERED_EVENTS),
      tooltipMessage: lang.headerCustomerTriggeredEvents,
    },
    {
      icon: <RotateLeftIcon />,
      onClick: () => navigate({ pathname: PATHS.SETTINGS_ACTION_TRACKING }),
      isSelected: paths.includes(PATHS.SETTINGS_ACTION_TRACKING),
      tooltipMessage: lang.actionTracking,
    },
    {
      icon: <AboutIcon />,
      onClick: () => navigate({ pathname: PATHS.SETTINGS_ABOUT }),
      isSelected: paths.includes(PATHS.SETTINGS_ABOUT),
      tooltipMessage: lang.about,
    },
  ];

  return (
    <Container>
      <MiniSidebar items={items} />

      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};
